import React from 'react';

const Quote = () => {
  return (
    <div className="Quote">
      <div className="Quote__Wrapper">
        <div className="Quote__Text">
          "We create value through how well we manage our assets. Rig transforms the way we optimize our rig portfolio by digitalizing the rig scheduling process and enabling flow efficiency through the asset value chain. Rig is built for the end users and provides the organization with full transparency and continuous improvement capabilities."
        </div>
        <div className="Quote__Byline">
          <span className="Quote__Byline--name">— David Rodrigues</span>
          <span className="Quote__Byline--title">D&W Manager Digitalisation, Aker BP</span>
        </div>
      </div>
    </div>
  );
};

export default Quote;



// WEBPACK FOOTER //
// ./src/components/Quote.js